import { useExperiments } from '@wix/yoshi-flow-editor';
import React, { FC } from 'react';
import { ExperimentsConsts } from '../../../../../consts/experiments';
import { TagName } from '../../../../../utils/tagName.const';
import Text, { TextType } from '../../../Text/Text';
import { DiscountRuleName, PriceBeforeDiscount } from '../../Discount/Discount';
import { classes } from './PriceItem.st.css';
import { PriceItemDataHooks } from './dataHooks';

export type PriceItemProps = {
  type: TextType;
  labels: string[];
  price: string;
  ariaPrice: string;
  dataHook?: string;
  discountRuleName?: string;
  priceBeforeDiscountText?: string;
};

export const PriceItem: FC<PriceItemProps> = ({
  type,
  labels,
  price,
  ariaPrice,
  dataHook,
  discountRuleName,
  priceBeforeDiscountText,
}) => {
  const { experiments } = useExperiments();
  return experiments.enabled(ExperimentsConsts.AutomaticDiscountsUoU) ? (
    <div
      className={classes.root}
      data-hook={dataHook || PriceItemDataHooks.Item}
    >
      <div className={classes.priceContainer}>
        <div>
          {labels.map((label, index) => (
            <Text
              key={index}
              type={type}
              tagName={TagName.Paragraph}
              data-hook={PriceItemDataHooks.Label}
            >
              {label}
            </Text>
          ))}
        </div>
        <div className={classes.prices}>
          <PriceBeforeDiscount price={priceBeforeDiscountText} type={type} />
          <Text
            className={classes.price}
            type={type}
            data-hook={PriceItemDataHooks.Price}
            tagName={TagName.Span}
            aria-label={ariaPrice}
          >
            {price}
          </Text>
        </div>
      </div>
      <DiscountRuleName name={discountRuleName} />
    </div>
  ) : (
    <div
      className={classes.deprecatedRoot}
      data-hook={dataHook || PriceItemDataHooks.Item}
    >
      <div>
        {labels.map((label, index) => (
          <Text
            key={index}
            type={type}
            tagName={TagName.Paragraph}
            data-hook={PriceItemDataHooks.Label}
          >
            {label}
          </Text>
        ))}
      </div>
      <Text
        className={classes.price}
        type={type}
        data-hook={PriceItemDataHooks.Price}
        tagName={TagName.Span}
        aria-label={ariaPrice}
      >
        {price}
      </Text>
    </div>
  );
};
